/* PDP clone kit – countdown bar. Ticks once a second, only while the bar is on screen (IntersectionObserver); the
   remaining time always comes from the clock, so a paused bar is right again the moment it shows.
   G Dash (#obcount): "Counts down from page load" is each visitor's own countdown. Its start is kept in the visitor's
   browser (per section and length), so a reload or a new tab carries on where it was; at zero it starts again from its
   full length and keeps looping. "Counts down to a date" counts to that date and stays at zero, as before. */
(function () {
  'use strict';
  var PDP = window.PDP || {};
  var define = PDP.define || function (n, c) { if (window.customElements && !customElements.get(n)) customElements.define(n, c); };
  var mem = {};
  function two(n) { return n < 10 ? '0' + n : String(n); }
  function startOf(key) {
    var s = 0, now = Date.now();
    try { s = parseInt(window.localStorage.getItem(key), 10) || 0; } catch (e) {}
    if (!s) s = mem[key] || 0;
    if (!s || s > now) {
      s = now;
      try { window.localStorage.setItem(key, String(s)); } catch (e) {}
    }
    mem[key] = s;
    return s;
  }
  define('pdp-countdown', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this._ready) return;
      this._ready = true;
      this.h = this.querySelector('[data-cd-h]');
      this.m = this.querySelector('[data-cd-m]');
      this.s = this.querySelector('[data-cd-s]');
      this.len = 0;
      if (this.dataset.mode === 'date') {
        var t = Date.parse((this.dataset.end || '').trim().replace(' ', 'T'));
        this.end = isNaN(t) ? Date.now() : t;
      } else {
        this.len = (parseInt(this.dataset.seconds, 10) || 0) * 1000;
        var sec = this.closest('.shopify-section');
        this.start = this.len ? startOf('gd-cd:' + (sec && sec.id ? sec.id : 'pdp-countdown') + ':' + this.len / 1000) : 0;
        this.end = Date.now();
      }
      this.paint();
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (en) { self.run(en[en.length - 1].isIntersecting); });
        this._io.observe(this);
      } else this.run(true);
    }
    disconnectedCallback() { this.run(false); if (this._io) this._io.disconnect(); }
    run(on) {
      var self = this;
      clearTimeout(this._t);
      if (!on) return;
      var tick = function () {
        var left = self.paint();
        var at = self.len ? Date.now() - self.start : Date.now();
        if (left > 0) self._t = setTimeout(tick, 1000 - (at % 1000) + 5);
      };
      tick();
    }
    paint() {
      var left = this.len ? this.len / 1000 - Math.floor(((Date.now() - this.start) % this.len) / 1000)
        : Math.max(0, Math.round((this.end - Date.now()) / 1000));
      var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      if (this.h) this.h.textContent = two(h);
      if (this.m) this.m.textContent = two(m);
      if (this.s) this.s.textContent = two(s);
      return left;
    }
  });
})();
